<template>
    <div class="application-bar-container">
        <v-app-bar app color="primary" dark fixed elevate-on-scroll>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title class="toolbar-title">{{ title }}</v-toolbar-title>
            <v-spacer />
            <v-menu offset-y>
                <template v-slot:activator="{on, attrs}">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-account</v-icon>
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-item :to="{ name: 'change-password' }">
                        <v-list-item-icon class="menu-icon">
                            <v-icon dense>mdi-key-variant</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Ubah sandi</v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-icon class="menu-icon">
                            <v-icon dense>mdi-logout</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title @click="logout">Keluar</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-navigation-drawer app v-model="drawer" temporary fixed>
            <v-list nav dense>
                <v-list-item-group>
                    <v-list-item v-for="(menu, index) in menus" :key="index" :to="menu.to">
                        <v-list-item-icon>
                            <v-icon>{{ menu.icon }}</v-icon>
                            <v-list-item-title>{{ menu.title }}</v-list-item-title>
                        </v-list-item-icon>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>  
    </div>
</template>

<script lang="ts">
    import { Vue, Component, Watch } from 'vue-property-decorator';
    import { MenuModel } from '@/models/components/menu.model';
    import { sbsModule } from '@/store';
    import applicationBarModule from '@/store/modules/application.bar.module';
    import applicationModule from '@/store/modules/application.module';

    @Component
    export default class ApplicationBar extends Vue {
        drawer: boolean = false;
    
        get title() : string {
            return applicationBarModule.Title;
        }
    
        get menus() : Array<MenuModel> {
            return [
                { icon: 'mdi-file-document', title: 'Laporan Stok', to: { name: 'stock-report' }},
                { icon: 'mdi-file-document', title: 'Laporan Transaksi', to: { name: 'transaction-report' }},
                { icon: 'mdi-file-document', title: 'Laporan Ringkas Transaksi', to: { name: 'transaction-summary-report' }},
                { icon: 'mdi-file-document', title: 'Laporan Ringkas Presensi', to: { name: 'attendence-report' }},
                { icon: 'mdi-file-document', title: 'Laporan Lembur', to: { name: 'overtime-report' }}
            ]
        }

        logout() : void {
            sbsModule.clearToken();
            applicationModule.setAuthorized(false);
            this.$router.push({ name: 'login' });
        }
    }
</script>

<style scoped>
    .toolbar-title {
        padding-left: 10px !important;
    }
    
    .menu-icon {
        margin-right: 15px !important;
    }
</style>